export const executeLazyPromise = (promise, onLoadingChange, minDuration = 10) => {
    if (!minDuration) {
        return Promise.resolve(promise());
    }
    const timeout = setTimeout(() => onLoadingChange(true), minDuration);
    return Promise.resolve(promise()).then(() => {
        clearTimeout(timeout);
        onLoadingChange(false);
    });
};
